import * as React from "react";
import SimpleSelect, {SimpleSelectItem} from "components/form/Select/SimpleSelect";
import {SecondaryUptimeStatus} from "client/resources/secondaryUptimeStatus";

interface SecondaryUptimeStatusSelectProps {
    value: string | undefined;
    onChange(newValue: string): void;
}

const items: SimpleSelectItem[] = [
    {value: "", text: ""},
    {value: SecondaryUptimeStatus.Down, text: SecondaryUptimeStatus.Down},
    {value: SecondaryUptimeStatus.Unknown, text: SecondaryUptimeStatus.Unknown},
    {value: SecondaryUptimeStatus.Up, text: SecondaryUptimeStatus.Up},
];

const SecondaryUptimeStatusSelect: React.FC<SecondaryUptimeStatusSelectProps> = props => (
    <SimpleSelect
        label="Secondary Uptime Status"
        value={props.value}
        onChange={props.onChange}
        items={items}
    />
);

export default SecondaryUptimeStatusSelect;
